document.addEventListener('DOMContentLoaded', () => {
    const viewer = document.getElementById('pamphletViewer');
    if (!viewer) return;

    const pages = Array.from(viewer.querySelectorAll('.pamphlet-page'));
    const thumbs = Array.from(viewer.querySelectorAll('.pamphlet-thumb'));
    const currentPageEl = document.getElementById('pamphletCurrentPage');
    const thumbScroller = document.getElementById('pamphletThumbnails');
    const listButton = document.getElementById('pamphletListButton');
    const prevButtons = Array.from(viewer.querySelectorAll('[data-pamphlet-nav="prev"]'));
    const nextButtons = Array.from(viewer.querySelectorAll('[data-pamphlet-nav="next"]'));

    if (pages.length === 0) return;

    const eventKey = viewer.dataset.eventKey || '';

    const buildTrackedUrl = (rawUrl, hotspotId, pageNumber) => {
        try {
            const url = new URL(rawUrl, window.location.origin);
            url.searchParams.set('utm_source', 'pamphlet');
            url.searchParams.set('utm_medium', 'referral');
            url.searchParams.set('utm_campaign', `pamphlet_${eventKey}`);
            url.searchParams.set('utm_content', `p${pageNumber}_h${hotspotId}`);
            return url.toString();
        } catch (e) {
            return rawUrl;
        }
    };

    const trackHotspotClick = (linkType, rawUrl, hotspotId, pageNumber) => {
        if (typeof window.gtag !== 'function') return;

        window.gtag('event', 'pamphlet_link_click', {
            link_url: rawUrl,
            link_type: linkType,
            page_number: pageNumber,
            hotspot_id: hotspotId,
            pamphlet_key: eventKey,
        });
    };

    viewer.querySelectorAll('.pamphlet-hotspot[data-action="internal"], .pamphlet-hotspot[data-action="external"]').forEach((hotspot) => {
        const rawUrl = hotspot.dataset.url;
        if (!rawUrl) return;

        const action = hotspot.dataset.action;
        const hotspotId = hotspot.dataset.hotspotId || '0';
        const page = hotspot.closest('.pamphlet-page');
        const pageNumber = page ? Number.parseInt(page.dataset.pageIndex || '0', 10) + 1 : 1;

        hotspot.addEventListener('click', () => {
            trackHotspotClick(action, rawUrl, hotspotId, pageNumber);
            const trackedUrl = buildTrackedUrl(rawUrl, hotspotId, pageNumber);

            if (action === 'external') {
                window.open(trackedUrl, '_blank', 'noopener');
            } else {
                window.location.href = trackedUrl;
            }
        });
    });

    let currentIndex = 0;
    let didDragThumbs = false;

    const clampIndex = (index) => Math.max(0, Math.min(index, pages.length - 1));

    const setActivePage = (index) => {
        currentIndex = clampIndex(index);

        pages.forEach((page, pageIndex) => {
            const active = pageIndex === currentIndex;
            page.classList.toggle('is-active', active);
            page.hidden = !active;
        });

        thumbs.forEach((thumb, thumbIndex) => {
            const active = thumbIndex === currentIndex;
            thumb.classList.toggle('is-active', active);

            if (active) {
                thumb.setAttribute('aria-current', 'page');
            } else {
                thumb.removeAttribute('aria-current');
            }
        });

        if (currentPageEl) {
            currentPageEl.textContent = String(currentIndex + 1);
        }

        prevButtons.forEach((button) => button.toggleAttribute('disabled', currentIndex === 0));
        nextButtons.forEach((button) => button.toggleAttribute('disabled', currentIndex === pages.length - 1));

        thumbs[currentIndex]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });
    };

    let thumbImagesLoaded = false;

    const loadThumbImages = () => {
        if (thumbImagesLoaded || !thumbScroller) return;

        thumbScroller.querySelectorAll('img[data-src]').forEach((image) => {
            image.src = image.dataset.src;
            image.removeAttribute('data-src');
        });

        thumbImagesLoaded = true;
    };

    prevButtons.forEach((button) => button.addEventListener('click', () => setActivePage(currentIndex - 1)));
    nextButtons.forEach((button) => button.addEventListener('click', () => setActivePage(currentIndex + 1)));
    listButton?.addEventListener('click', loadThumbImages);

    thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (event) => {
            if (didDragThumbs) {
                event.preventDefault();
                return;
            }

            const index = Number.parseInt(thumb.dataset.pageIndex || '0', 10);
            setActivePage(index);
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
            setActivePage(currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
            setActivePage(currentIndex + 1);
        }
    });

    // ===== ポインタドラッグの共通トラッキング =====
    // mouse / touch / pen を Pointer Events に統一して扱う。
    // 対象要素側で setPointerCapture は使わず、window に一時的にリスナーを
    // 貼ることで「要素外に出てもドラッグを追従できる」状態を作る。
    // これにより、ドラッグ判定のために親要素へ pointer capture をかけることで
    // 子要素(サムネイル/ホットスポット)の click イベントが親側にすり替わってしまう
    // 問題を避けられる。
    const trackPointer = (pointerId, handlers) => {
        const cleanup = () => {
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup', onUp);
            window.removeEventListener('pointercancel', onCancel);
        };

        const onMove = (event) => {
            if (event.pointerId !== pointerId) return;
            handlers.onMove?.(event, cleanup);
        };

        const onUp = (event) => {
            if (event.pointerId !== pointerId) return;
            cleanup();
            handlers.onEnd?.(event);
        };

        const onCancel = (event) => {
            if (event.pointerId !== pointerId) return;
            cleanup();
            handlers.onCancel?.(event);
        };

        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onCancel);
    };

    // ===== サムネイル一覧のドラッグスクロール =====
    if (thumbScroller) {
        thumbScroller.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse' && event.button !== 0) return;

            didDragThumbs = false;
            const startX = event.clientX;
            const startScrollLeft = thumbScroller.scrollLeft;
            thumbScroller.classList.add('is-dragging');

            trackPointer(event.pointerId, {
                onMove: (moveEvent) => {
                    if (Math.abs(moveEvent.clientX - startX) > 6) {
                        didDragThumbs = true;
                    }
                    thumbScroller.scrollLeft = startScrollLeft - (moveEvent.clientX - startX);
                },
                onEnd: () => {
                    thumbScroller.classList.remove('is-dragging');
                    window.setTimeout(() => {
                        didDragThumbs = false;
                    }, 150);
                },
                onCancel: () => {
                    thumbScroller.classList.remove('is-dragging');
                    didDragThumbs = false;
                },
            });
        });
    }

    setActivePage(0);
});
